/* eslint-disable  */
import React, { useState } from 'react';
import classNames from 'classnames';
import useSchoolSelect from 'components/profile/education-hooks/useSchoolSelect';
import moment from 'moment';
import { getCitizenIdType } from 'helpers';
import { CURRENT_TCAS_LABEL } from 'constants/school-year';

// Components
import ErrorBox from 'components/registrations/ErrorBox';
import AsyncSelect from 'react-select/async';

// Hooks
import useNotFoundTicket from 'hooks/useNotFoundTicket';

const ID = 'not-found-ticket';
const NotFoundTicket = ({
  citizenId,
  citizenTypeLabel,
  isTcas = false,
  prefill,
  headingTitle,
  onSubmitSuccess,
  onBack,
}) => {
  const {
    email,
    mobile,
    title,
    firstName,
    lastName,
    birthDate,
    errors,

    onEmailChange,
    onMobileChange,
    onTitleChange,
    onFirstNameChange,
    onLastNameChange,
    onBirthDateChange,

    onCitizenCardFileChange,
    onSelfieFileChange,

    onSubmit,
    submitting,
    submitSuccess,
  } = useNotFoundTicket(citizenId, isTcas, onSubmitSuccess, prefill);
  const nameLang = getCitizenIdType(citizenId) === 'passport' ? 'ภาษาอังกฤษ' : 'ภาษาไทย';
  const {
    schoolCode,
    onSchoolCodeChange,

    onOptionsLoad,
    defaultOptions,
    selectedOption,
    onSelectedOptionChange,
  } = useSchoolSelect();

  if (submitSuccess) {
    return (
      <div className="t-form">
        <h1>
          {'ลงทะเบียน'} • {'เข้าสู่ระบบ'}
        </h1>
        <p className="text-center">
          <svg width="213" height="122" viewBox="0 0 213 122" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_71:8258)">
              <rect x="6.45386" y="4" width="200" height="110" rx="5" fill="url(#paint0_linear_71:8258)" />
              <circle cx="28.6264" cy="26.6274" r="12.605" fill="white" />
              <g filter="url(#filter1_d_71:8258)">
                <path
                  d="M64.9952 31.0291L62.7232 27.0611L64.8192 23.4291H62.8352L61.7472 25.5731L60.6912 23.4291H58.5952L60.6912 27.1411L58.4352 31.0291H60.4672L61.7152 28.5971L62.8992 31.0291H64.9952ZM77.1346 31.0291L74.8626 27.0611L76.9586 23.4291H74.9746L73.8866 25.5731L72.8306 23.4291H70.7346L72.8306 27.1411L70.5746 31.0291H72.6066L73.8546 28.5971L75.0386 31.0291H77.1346ZM84.6809 31.0291L82.4089 27.0611L84.5049 23.4291H82.5209L81.4329 25.5731L80.3769 23.4291H78.2809L80.3769 27.1411L78.1209 31.0291H80.1529L81.4009 28.5971L82.5849 31.0291H84.6809ZM92.2271 31.0291L89.9551 27.0611L92.0511 23.4291H90.0671L88.9791 25.5731L87.9231 23.4291H85.8271L87.9231 27.1411L85.6671 31.0291H87.6991L88.9471 28.5971L90.1311 31.0291H92.2271ZM99.7734 31.0291L97.5014 27.0611L99.5974 23.4291H97.6134L96.5254 25.5731L95.4694 23.4291H93.3734L95.4694 27.1411L93.2134 31.0291H95.2454L96.4934 28.5971L97.6774 31.0291H99.7734ZM111.913 31.0291L109.641 27.0611L111.737 23.4291H109.753L108.665 25.5731L107.609 23.4291H105.513L107.609 27.1411L105.353 31.0291H107.385L108.633 28.5971L109.817 31.0291H111.913ZM119.459 31.0291L117.187 27.0611L119.283 23.4291H117.299L116.211 25.5731L115.155 23.4291H113.059L115.155 27.1411L112.899 31.0291H114.931L116.179 28.5971L117.363 31.0291H119.459ZM127.005 31.0291L124.733 27.0611L126.829 23.4291H124.845L123.757 25.5731L122.701 23.4291H120.605L122.701 27.1411L120.445 31.0291H122.477L123.725 28.5971L124.909 31.0291H127.005ZM134.551 31.0291L132.279 27.0611L134.375 23.4291H132.391L131.303 25.5731L130.247 23.4291H128.151L130.247 27.1411L127.991 31.0291H130.023L131.271 28.5971L132.455 31.0291H134.551ZM142.098 31.0291L139.826 27.0611L141.922 23.4291H139.938L138.85 25.5731L137.794 23.4291H135.698L137.794 27.1411L135.538 31.0291H137.57L138.818 28.5971L140.002 31.0291H142.098ZM154.237 31.0291L151.965 27.0611L154.061 23.4291H152.077L150.989 25.5731L149.933 23.4291H147.837L149.933 27.1411L147.677 31.0291H149.709L150.957 28.5971L152.141 31.0291H154.237ZM161.783 31.0291L159.511 27.0611L161.607 23.4291H159.623L158.535 25.5731L157.479 23.4291H155.383L157.479 27.1411L155.223 31.0291H157.255L158.503 28.5971L159.687 31.0291H161.783ZM173.923 31.0291L171.651 27.0611L173.747 23.4291H171.763L170.675 25.5731L169.619 23.4291H167.523L169.619 27.1411L167.363 31.0291H169.395L170.643 28.5971L171.827 31.0291H173.923Z"
                  fill="#1A477F"
                />
              </g>
              <rect x="148.471" y="50.4285" width="47.7941" height="51.8908" rx="2" fill="white" />
            </g>
            <defs>
              <filter
                id="filter0_d_71:8258"
                x="0.453857"
                y="0"
                width="212"
                height="122"
                filterUnits="userSpaceOnUse"
                colorInterpolation-filters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_71:8258" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_71:8258" result="shape" />
              </filter>
              <filter
                id="filter1_d_71:8258"
                x="55.4352"
                y="21.4291"
                width="121.487"
                height="13.6"
                filterUnits="userSpaceOnUse"
                colorInterpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_71:8258" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_71:8258" result="shape" />
              </filter>
              <linearGradient
                id="paint0_linear_71:8258"
                x1="205.824"
                y1="4.00001"
                x2="5.82098"
                y2="112.837"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#94D7EA" />
                <stop offset="0.507792" stopColor="#6BD5F3" />
                <stop offset="1" stopColor="#417CC5" />
              </linearGradient>
            </defs>
          </svg>
        </p>

        <div className="t-box -success">
          <h2>{'ได้รับข้อมูลและยืนยันไปทางอีเมลเรียบร้อย'}</h2>
          {`หลังจากนี้ทีมงาน ${CURRENT_TCAS_LABEL} จะตรวจสอบ และยืนยันสถานะกลับไปทางอีเมล`} <b>{email}</b>{' '}
          {'ภายในเวลา 72 ชั่วโมง'} {'กรุณาเพิ่มอีเมล'} <b>no-reply@mytcas.com</b>{' '}
          {`ไว้ในสมุดรายชื่อ เพื่อไม่พลาดการติดต่อจากทีมงาน ${CURRENT_TCAS_LABEL}`}
        </div>
      </div>
    );
  }

  return (
    <div id={ID}>
      <h2 className="text-center">{(headingTitle || 'แจ้งข้อมูลเพิ่มเติม')}</h2>
      <ErrorBox hidden={!errors.length} errors={errors} />
      <div className="t-row">
        <div className="col required valid">
          <label className="has-meta">
            <span>{'เลขประจำตัว'}</span>
            <span className="meta">({citizenTypeLabel})</span>
          </label>
          <input type="text" value={citizenId} disabled required />
        </div>
        <div className="col required">
          <label>{'อีเมล'}</label>
          <input
            type="email"
            placeholder={'กรอกอีเมล เช่น mytcas70@gmail.com'}
            required
            value={email}
            onChange={onEmailChange}
          />
        </div>
        <div className="col required">
          <label>{'เบอร์โทรศัพท์มือถือ'}</label>
          <input type="tel" placeholder={'กรอกเลข 10 หลัก'} required value={mobile} onChange={onMobileChange} />
        </div>
        <div className="col required">
          <label>{'คำนำหน้า'}</label>
          <div className="inline-group">
            <input type="radio" name="title" id="mr" checked={title === 'นาย'} onChange={() => onTitleChange('นาย')} />
            <label htmlFor="mr">{'นาย'}</label>
            <input
              type="radio"
              name="title"
              id="ms"
              checked={title === 'นางสาว'}
              onChange={() => onTitleChange('นางสาว')}
            />
            <label htmlFor="ms">{'นางสาว'}</label>
          </div>
        </div>
        <div className="col required">
          <label className="has-meta">
            <span>{'ชื่อ'}</span>
            <span className="meta">({nameLang}เท่านั้น)</span>
          </label>
          <input
            type="text"
            name="first-name"
            placeholder={`กรอกชื่อจริง${nameLang} ไม่ต้องใส่คำนำหน้า`}
            required
            value={firstName}
            onChange={onFirstNameChange}
          />
        </div>
        <div className="col required">
          <label className="has-meta">
            <span>{'นามสกุล'}</span>
            <span className="meta">({nameLang}เท่านั้น)</span>
          </label>
          <input
            type="text"
            name="last-name"
            placeholder={`กรอกนามสกุล${nameLang}`}
            required
            value={lastName}
            onChange={onLastNameChange}
          />
        </div>
        <div className="col required">
          <label>{'วันเดือนปีเกิด'}</label>
          <input
            type="date"
            min="1977-01-01"
            max={moment([moment().year() - 15, 11, 31]).format('YYYY-MM-DD')}
            required
            onKeyDown={(e) => e.preventDefault()}
            value={birthDate}
            onChange={onBirthDateChange}
          />
        </div>
        <div className="col required">
          <label>{'ชื่อโรงเรียน'}</label>
          <AsyncSelect
            placeholder="พิมพ์เพื่อค้นหาชื่อโรงเรียน"
            noOptionsMessage={() => <div style={{ textAlign: 'left' }}>พิมพ์เพื่อค้นหาชื่อโรงเรียน</div>}
            defaultOptions={defaultOptions}
            loadOptions={onOptionsLoad}
            value={selectedOption}
            onChange={onSelectedOptionChange}
          />
        </div>
      </div>
      <h3>{'เอกสารยืนยันตัวตน'}</h3>
      <div className="t-box -info">
        {'ให้ถ่ายรูปบัตรประชาชนและถ่ายรูปคู่กับบัตรประชาชนตามตัวอย่าง หากไม่มีบัตรประชาชน ให้ใช้ Passport แทน'}
      </div>

      <div className="t-row">
        <div className="col required">
          <div className="kyc">
            <img src="/assets/img/cid.jpg" alt="รูปด้านหน้าบัตรประจำตัว" />
            {'รูปด้านหน้าบัตรประจำตัว'}
          </div>
          <label>{'อัปโหลดรูปด้านหน้า'}</label>
          <input type="file" accept="image/jpeg,image/png" onChange={onCitizenCardFileChange} />
        </div>
        <div className="col required">
          <div className="kyc">
            <img src="/assets/img/cid-kyc.png" alt="รูปถ่ายคู่บัตรประจำตัว" />
            {'รูปถ่ายคู่บัตรประจำตัว'}
          </div>
          <label>{'อัปโหลดรูปถ่าย'}</label>
          <input type="file" accept="image/jpeg,image/png" onChange={onSelfieFileChange} />
        </div>
      </div>
      <div className="t-box -error">
        <h2>คำเตือน</h2>
        หากแจ้งข้อมูลซ้ำ ระบบจะลบคำร้องเก่า และนำคำร้องใหม่ไปต่อคิว ซึ่งอาจต้องรอเพิ่มอีก 72 ชั่วโมง
      </div>
      <div className="action">
        <p>
          <a
            className={classNames('btn-main cursor-pointer', { disabled: submitting })}
            onClick={submitting ? () => { } : () => onSubmit(selectedOption)}
          >
            {'แจ้งข้อมูลเพื่อยืนยันตัวตน'}
          </a>
        </p>
        {Boolean(onBack) && (
          <small className="_heading">
            <a className="cursor-pointer" onClick={onBack}>
              ← {'กลับไปกรอกชื่อ นามสกุล ใหม่อีกครั้ง'}
            </a>
          </small>
        )}
      </div>
    </div>
  );
};

export default NotFoundTicket;
